import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { store } from '../../redux/oldStore';
import { IState } from '../../redux/redux';
import { ServerResponse } from '../../utils/Server';
import Icon, { IconType } from '../Icon/Icon';

interface SelfRemoveFromEventProps {
  variant: 'menu' | 'page';
}

const confirmAndRemove = (displayName: string) => {
  if (
    !window.confirm(
      `This will remove you from this event and deactivate your account for this event.\n\nRemove ${displayName || 'yourself'} from this event?`
    )
  ) {
    return;
  }
  if (!window.confirm('Are you sure? You will be signed out. If you want to return later you will need to register again.')) {
    return;
  }

  store.server.postApi<ServerResponse<unknown>>('../Person/RemoveMyself', {}).then((x) => {
    if (x.Success) {
      window.location.href = x.GoTo || `/app/logout${window.location.search}`;
      return;
    }
    toast.error(x.Message || 'Unable to leave this event.', { autoClose: false });
  });
};

const SelfRemoveFromEvent = (props: IState & SelfRemoveFromEventProps) => {
  if (!props.Settings?.AllowUsersToRemoveThemselvesFromEvent) return null;
  if (!props.User?.signedIn) return null;

  if (props.variant === 'page') {
    const m = window.location.pathname.match(/\/app\/user\/profile\/([^/?#]+)/i);
    const targetId = m?.[1];
    if (targetId && props.User.id && targetId.toLowerCase() !== props.User.id.toLowerCase()) {
      return null;
    }
  }

  const name = `${props.User.firstName ?? ''} ${props.User.lastName ?? ''}`.trim();

  if (props.variant === 'menu') {
    return (
      <li>
        <a
          className="text-danger"
          data-testid="leave-event-menu"
          onClick={(e) => {
            e.preventDefault();
            confirmAndRemove(name);
          }}>
          <i className="fa fa-user-times"></i> Leave this event
        </a>
      </li>
    );
  }

  return (
    <div className="alert alert-danger bumper-out" data-testid="leave-event-panel">
      <h4>Leave this event</h4>
      <p>Remove yourself from this event. Your account for this event will be deactivated. Paid orders must be refunded first.</p>
      <button type="button" className="btn btn-danger" data-testid="remove-my-account" onClick={() => confirmAndRemove(name)}>
        <Icon type={IconType.delete} /> Remove my account
      </button>
    </div>
  );
};

const mapStateToProps = (state: { main: IState }) => {
  return { ...state.main };
};

export default connect(mapStateToProps)(SelfRemoveFromEvent);
